var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 458 332",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1742_3807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0901 5.94727C17.2871 5.94727 2.03809 21.1953 2.03809 39.9983C2.03809 58.8013 17.2871 74.0503 36.0901 74.0503C54.8931 74.0503 70.1421 58.8003 70.1421 39.9983C70.1421 21.1953 54.8931 5.94727 36.0901 5.94727Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.537 80H416.141C438.233 80 456.141 62.092 456.141 40C456.141 17.908 438.233 0 416.141 0H147.537C125.445 0 107.537 17.908 107.537 40C107.537 62.092 125.445 80 147.537 80Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0901 132.008C17.2871 132.008 2.03809 147.256 2.03809 166.059C2.03809 184.862 17.2871 200.111 36.0901 200.111C54.8931 200.111 70.1421 184.862 70.1421 166.059C70.1421 147.256 54.8931 132.008 36.0901 132.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.142 126.061H147.537C125.445 126.061 107.537 143.969 107.537 166.061C107.537 188.153 125.445 206.061 147.537 206.061H416.141C438.233 206.061 456.141 188.153 456.141 166.061C456.141 143.969 438.233 126.061 416.142 126.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0901 258.068C17.2871 258.068 2.03809 273.316 2.03809 292.119C2.03809 310.922 17.2871 326.171 36.0901 326.171C54.8931 326.171 70.1421 310.922 70.1421 292.119C70.1421 273.316 54.8931 258.068 36.0901 258.068Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.142 252.119H147.537C125.445 252.119 107.537 270.027 107.537 292.119C107.537 314.211 125.445 332.119 147.537 332.119H416.141C438.233 332.119 456.141 314.211 456.141 292.119C456.141 270.027 438.233 252.119 416.142 252.119Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1742_3807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 458,
    height: 332,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.baee494a.svg";
export { ForwardRef as ReactComponent };